import { useState } from 'react';

export const useDuplicateBroadcast = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const duplicateBroadcast = async (originalBroadcastId, duplicateData) => {
    setIsLoading(true);
    setError(null);

    try {
      const token = localStorage.getItem('prae.jwt');
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/broadcasts/${originalBroadcastId}/duplicate`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
          body: JSON.stringify(duplicateData),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.error || 'Erreur lors de la duplication du broadcast'
        );
      }

      const result = await response.json();
      return result;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  return { duplicateBroadcast, isLoading, error };
};
